'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: '時刻を選択'
};

exports['default'] = locale;